import i18n from '@/libs/i18n'

export default [
  // *===============================================---*
  // *--------- MANAGER ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/managers/list',
    name: 'pages-managers-list',
    component: () => import('@/views/pages/manager/ManagerList.vue'),
    meta: {
      action: 'read',
      resource: 'manager',
      required: true,
      breadcrumb: [
        {
          text: i18n.t('general.list'),
          active: false,
        },
      ],
      pageTitle: i18n.t('managers.mainVerticalMenu.managers'),
    },
  },
  {
    path: '/managers/add',
    name: 'pages-managers-add',
    component: () => import('@/views/pages/manager/ManagerAdd.vue'),
    meta: {
      resource: 'manager',
      action: 'create',
      breadcrumb: [
        {
          text: i18n.t('general.add'),
          active: false,
        },
      ],
      pageTitle: i18n.t('managers.mainVerticalMenu.managers'),
    },
  },
  {
    path: '/managers/edit/:id',
    name: 'pages-managers-edit',
    component: () => import('@/views/pages/manager/ManagerEdit.vue'),
    meta: {
      resource: 'manager',
      action: 'update',
      breadcrumb: [
        {
          text: i18n.t('general.edit'),
          active: false,
        },
      ],
      pageTitle: i18n.t('managers.mainVerticalMenu.managers'),
    },
  },
  // *===============================================---*
  // *--------- MANAGER Category ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/managers/categories/list',
    name: 'pages-manager-categories-list',
    component: () => import('@/views/pages/managerCategory/ManagerCategoryList.vue'),
    meta: {
      resource: 'managerCategory',
      action: 'list',
      breadcrumb: [
        {
          text: i18n.t('general.list'),
          active: false,
        },
      ],
      pageTitle: i18n.t('managerCategories.mainVerticalMenu.managerCategory'),
    },
  },
  {
    path: '/managers/categories/add',
    name: 'pages-manager-categories-add',
    component: () => import('@/views/pages/managerCategory/ManagerCategoryAdd.vue'),
    meta: {
      resource: 'managerCategory',
      action: 'create',
      breadcrumb: [
        {
          text: i18n.t('general.add'),
          active: false,
        },
      ],
      pageTitle: i18n.t('managerCategories.mainVerticalMenu.managerCategory'),
    },
  },
  {
    path: '/managers/categories/edit/:id',
    name: 'pages-manager-categories-edit',
    component: () => import('@/views/pages/managerCategory/ManagerCategoryEdit.vue'),
    meta: {
      resource: 'managerCategory',
      action: 'update',
      breadcrumb: [
        {
          text: i18n.t('general.edit'),
          active: false,
        },
      ],
      pageTitle: i18n.t('managerCategories.mainVerticalMenu.managerCategory'),
    },
  },
]
